__turbopack_context__.v({
  "progressBar": "KI-LwW_progressBar",
  "progressBarInner": "KI-LwW_progressBarInner",
  "progressBarStat": "KI-LwW_progressBarStat",
});
